console.log('dynamic-price.js: LOADED');
var variantPrice = 0;

function formatMoneyCents(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, window.DynamicPrice?.moneyFormat || '${{amount}}');
  }
  const cur = window.DynamicPrice?.currency || 'USD';
  return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format((cents||0)/100);
}

function applyVariantPriceRefresh(variantId, pr) {
  console.log("variantId: " + variantId + ", pr: " + pr)
  const root = document.querySelector('[id^="MainProduct-"]') || document;

  // Dawn renders price inside: <div id="price-{{ section.id }}"> ... </div>
  const priceRoot = root.querySelector('[id^="price-"]');
  if (!priceRoot) {
    console.warn('dynamic-price.js: price container not found');
    return;
  }

  // "Current" price shows up as .price-item--sale when discounted, otherwise .price-item--regular
  const current = priceRoot.querySelector('.price-item--sale, .price-item--regular');

  // "Compare at" price is usually the struck-through price in .price__sale .price-item--regular
  const compareWrap = priceRoot.querySelector('.price__sale');
  const compare = priceRoot.querySelector('.price__sale .price-item--regular, .price-item--compare');

  if (current && typeof pr?.priceCents === 'number') {
    current.textContent = formatMoneyCents(pr.priceCents);
    variantPrice = pr.priceCents
  }

  if (compare) {
    if (typeof pr?.compareAtCents === 'number' && pr.compareAtCents > (pr.priceCents || 0)) {
      compare.textContent = formatMoneyCents(pr.compareAtCents);
      compare.style.display = '';
      compareWrap?.classList.remove('hidden');
    } else {
      compare.textContent = '';
      compare.style.display = 'none';
      compareWrap?.classList.add('hidden');
    }
  }

  console.log('Applied price for', variantId, pr);

  /*
  if (regular && typeof pr?.priceCents === 'number') regular.textContent = formatMoneyCents(pr.priceCents);
  if (compare) {
    if (typeof pr?.compareAtCents === 'number' && pr.compareAtCents > (pr.priceCents||0)) {
      compare.textContent = formatMoneyCents(pr.compareAtCents);
      compare.style.display = '';
      compare.closest('.price__sale')?.classList.remove('hidden');
    } else {
      compare.textContent = '';
      compare.style.display = 'none';
      compare.closest('.price__sale')?.classList.add('hidden');
    }
  }
  console.log('Applied price for', variantId, pr);
    */
   // Add to cart overwrite
    // end add to cart overwrite
}

  /*
document.addEventListener('DOMContentLoaded', () => {
  const addToCartButton = document.querySelector('.product-form__submit.button'); // form[action="/cart/add"] button[type="submit"]'); // fallback: .product-form__submit.button
  const variantIdInput = document.querySelector('[name="id"]');
  const root = document.querySelector('[id^="MainProduct-"]') || document;

  if (!addToCartButton || !variantIdInput) return;
  

  addToCartButton.replaceWith(addToCartButton.cloneNode(true));
  const freshButton = root.querySelector('.product-form__submit.button');
  freshButton.addEventListener('click', async (event) => {
    event.preventDefault(); // stop the default Shopify form submission

    const variantId = variantIdInput.value;
    console.log("variantPrice: " + variantPrice);

    // Add product to Shopify cart with dynamic price property      
    console.log("VariantID: " + variantId + ", quantity: 1, customPrice: " + variantPrice)
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            _dynamic_price: variantPrice
          }
        })
      });

      const data = await response.json();
      console.log('Item added to cart:', data);
      
      // Refresh cart drawer or cart page
      // window.location.href = '/cart';
    } catch (err) {
      console.error('Error adding to cart:', err);
    }
    
  });
});
  */
/*
(function init() {
  if (!window.DynamicPrice) return console.warn('dynamic-price.js: no DynamicPrice data block');
  const variants = window.DynamicPrice.variants || [];
  const tags = (window.DynamicPrice.tags || []).map(String);
  const pricingTag = tags.includes('WWPRICE') ? 'WWPRICE' : (tags[0] || 'WWPRICE');

  // Build batched payload: one line per SKU
  // const lines = variants.filter(v => v.sku && v.sku.trim()).map(v => `${v.sku},${pricingTag}`).join('\n');
  const lines = variants.filter(v => v.sku && v.sku.trim()).map(v => `${v.sku},${window.customerTags}`).join('|');
  if (!lines) return console.warn('No SKUs to price');
console.log(lines)
  fetch('https://shopifyapp.wingits.com/', {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: lines,
    mode: 'cors',
    credentials: 'omit'
  })
  .then(r => r.text())
  .then(csv => {
    // CSV → { sku: {priceCents, compareAtCents?} }
    console.log("CSV: " + csv)
    const bySku = {};
    csv.trim().split(/\r?\n/).forEach(line => {
      const [sku, priceStr, compareStr] = line.split(',').map(s => s?.trim());
      const price = Number(priceStr), cmp = Number(compareStr);
      if (sku && Number.isFinite(price)) {
        bySku[sku] = {
          priceCents: Math.round(price * 100),
          compareAtCents: Number.isFinite(cmp) ? Math.round(cmp * 100) : undefined
        };
      }
    });
    // Map to { variantId: pricing }
    const byVariantId = {};
    variants.forEach(v => {
      if (v?.id && v?.sku && bySku[v.sku]) byVariantId[v.id] = bySku[v.sku];
    });

    // expose a helper for your other script (optional)
    window.applyDynamicPriceBySku = (sku) => {
      const v = variants.find(x => x.sku === sku);
      if (v && byVariantId[v.id]) applyVariantPriceRefresh(v.id, byVariantId[v.id]);
    };

    // Apply to current variant
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const currentId = idInput?.value ? Number(idInput.value) : null;
    if (currentId && byVariantId[currentId]) applyVariantPriceRefresh(currentId, byVariantId[currentId]);

    // Re-apply on variant change
    document.addEventListener('variant:change', (e) => {
      const v = e?.detail?.variant;
      if (v?.id && byVariantId[v.id]) applyVariantPriceRefresh(v.id, byVariantId[v.id]);
    });

    // Fallback: watch the hidden id input
    if (idInput) {
      idInput.addEventListener('change', () => {
        const vid = Number(idInput.value);
        if (byVariantId[vid]) applyVariantPriceRefresh(vid, byVariantId[vid]);
      });
    }
  })
  .catch(err => console.error('dynamic-price.js: pricing fetch failed', err));
})();
*/
